export const checkValidSchedule = (window: {
  start_epoch: Date | null;
  end_epoch: Date | null;
}): boolean => {
  const { start_epoch, end_epoch } = window;
  return Boolean(
    start_epoch && end_epoch && new Date(end_epoch).getTime() - new Date(start_epoch).getTime() > 0
  );
};
